import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FullScreen from './../full_screen';
import Padded from './padded';
import HeaderWithActions from '../shared/header_with_actions';
import cx from 'classnames';
import React from 'react';
import SessionStorageHelper from '../../helpers/session_storage_helper';
import Box from '@mui/material/Box';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen,
      userPreferredEmailSessionStorage: SessionStorageHelper.getDataFromSession('userPreferredEmail'),
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isOpen: true });
    }, 10);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isOpen } = this.props;
    if (prevState.isOpen === true && isOpen === false) {
      this.setState({ isOpen });
    }
  }

  render() {
    const {
      id,
      children,
      title,
      headerActions,
      hideHeader,
      container,
      lastEvent,
      customer,
      footerClass,
      minWidth,
      stackedPopup,
      responsive,
      financingMethod,
      financingRequest,
      userPreferredEmail,
      userPreferredEmailDismissed,
      view: { page },
      fullScreen,
      modalMargin,
      className,
    } = this.props;
    const { userPreferredEmailSessionStorage } = this.state;
    let transitionClass = 'open',
      transformOrigin = '';
    let withConfirmEmail = false;
    if (lastEvent) {
      const {
        rect: { top, left },
      } = lastEvent;
      transitionClass = this.state.isOpen ? 'open' : 'closed';
      transformOrigin = `${left}px ${top}px`;
    }
    let proposalId = financingMethod?.proposalId;
    if (
      userPreferredEmail === null &&
      !userPreferredEmailSessionStorage &&
      !userPreferredEmailDismissed &&
      page !== 'homeownerEligibility' &&
      page !== 'adminProposalMeasures'
    ) {
      withConfirmEmail = true;
    }
    return (
      <FullScreen
        className={cx({ responsive: responsive, [className]: !!className })}
        withHeader
        withConfirmEmail={withConfirmEmail}
        container={container}
        stackedPopup={stackedPopup}
      >
        <Box id={id} className={fullScreen ? 'full-screen' : 'modal-wrapper'} minWidth={minWidth}>
          <div
            className={`${transitionClass} modal`}
            style={{
              transformOrigin,
              borderRadius: '10px',
              height: fullScreen ? '100%' : undefined,
              margin: modalMargin ? modalMargin : undefined,
            }}
          >
            {!hideHeader && (
              <div className="modal-header">
                <Padded>
                  <HeaderWithActions title={title} actions={headerActions} />
                </Padded>
              </div>
            )}

            {children}
            <div className={cx(footerClass, 'modal-footer')}>
              {customer && (
                <div className="modal-padded">
                  {financingRequest && (
                    <div className="footer-item">
                      <span className="caption caption-bold">Financing Request ID:</span> {financingRequest.id}
                    </div>
                  )}
                  {proposalId && (
                    <div className="footer-item">
                      <span className="caption caption-bold">Proposal ID:</span> {proposalId}
                    </div>
                  )}
                  {customer?.id && (
                    <div className="footer-item">
                      <span className="caption caption-bold">Customer ID:</span> {customer?.id}
                    </div>
                  )}
                  {customer?.currentCreditCheckId && (
                    <div className="footer-item">
                      <span className="caption caption-bold">CreditCheck ID:</span> {customer?.currentCreditCheckId}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Box>
      </FullScreen>
    );
  }
}

Modal.propTypes = {
  container: PropTypes.object.isRequired,
  responsive: PropTypes.bool,
  title: PropTypes.node,
  headerActions: PropTypes.node,
  lastEvent: PropTypes.object,
  customer: PropTypes.object,
  footerClass: PropTypes.string,
  stackedPopup: PropTypes.bool,
  financingMethod: PropTypes.object,
  financingRequest: PropTypes.object,
  userPreferredEmail: PropTypes.any,
  userPreferredEmailDismissed: PropTypes.bool,
  view: PropTypes.object,
  fullScreen: PropTypes.bool,
  isOpen: PropTypes.bool,
};

const ConnectedModal = connect(({ financingMethod, userPreferredEmail, userPreferredEmailDismissed, view }) => ({
  financingMethod,
  userPreferredEmail,
  userPreferredEmailDismissed,
  view,
}))(Modal);

export default ConnectedModal;
